<script setup lang="ts">
import { Collaboration } from '@tiptap/extension-collaboration'
import { CollaborationCursor } from '@tiptap/extension-collaboration-cursor'
import { HocuspocusProvider } from '@hocuspocus/provider'
import type { Extensions, JSONContent } from "@tiptap/core";

const me = useMe()

const props = defineProps<{
  provider: HocuspocusProvider | null
  content: JSONContent | null
  extensions: Extensions
  limit?: number
  editable?: boolean
  field?: string
}>()

const emit = defineEmits<{
  (e: 'update:content', value: JSONContent | null): void,
}>()

const extensions = computed(() => {
  if (props.provider == null || me.value == null) {
    return props.extensions
  }

  return [
    ...props.extensions,
    Collaboration.configure({
      document: props.provider.document,
      field: props.field,
    }),
    CollaborationCursor.configure({
      provider: props.provider,
      user: {
        name: me.value.name,
        // TODO generate color from name?
        color: '#f783ac',
      },
    }),
  ]
})
</script>

<template>
  <Editor
    :content="props.content"
    @update:content="val => emit('update:content', val)"
    :extensions="extensions"
    :limit="props.limit"
    :editable="editable"
    #default="{ editor }"
  >
    <slot :editor="editor" />
  </Editor>
</template>

<!--suppress CssUnusedSymbol -->
<style scoped lang="postcss">
:deep(.collaboration-cursor__caret) {
  @apply relative border-l border-r
}

:deep(.collaboration-cursor__label) {
  @apply absolute bottom-[100%] mt-1 left-[-1px] p-1 text-xs text-gray-900 rounded rounded-bl-none overflow-hidden
}
</style>
